var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
        [_vm._v("考试中心")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.data.examName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "result-con" }, [
      _c("div", { staticClass: "count" }, [
        _c("h2", [_vm._v("考试结果")]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", [
            _vm.data.isPassed == "passed"
              ? _c("span", { staticClass: "result-txt" }, [
                  _vm._v("恭喜您已通过考试")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.isPassed == "failed"
              ? _c("span", { staticClass: "result-txt" }, [
                  _vm._v("很遗憾您未通过考试")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("用时："),
            _c("span", { staticClass: "blue" }, [
              _vm._v(_vm._s(_vm.getTime(_vm.data.examTimeSpent)))
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("label", [_vm._v("打字速度：")]),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.tjkAnswer.speed) + "字/分")
            ]),
            _vm._v(" "),
            _c("label", [_vm._v("正确率：")]),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.tjkAnswer.accuracy) + "%")
            ]),
            _vm._v(" "),
            _c("label", [_vm._v("总字数：")]),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.tjkAnswer.tjkWordNumber) + "字")
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt" }, [
            _vm._v("及格分数：" + _vm._s(_vm.data.examPassScore) + "字/分")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db5c012a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db5c012a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/typingResult.vue
// module id = 1137
// module chunks = 0